export enum TriggerType {
  organization = 'organization',
  contact = 'contact',
  deal = 'deal',
  contactOrg = 'contactOrg',
  automations = 'automations',
}

export type TriggerOperation = 'create' | 'update' | 'delete';

export const WEBHOOK_TRIGGERS = [TriggerType.organization, TriggerType.contact, TriggerType.deal, TriggerType.contactOrg, TriggerType.automations];
export const WEBHOOK_OPERATIONS: TriggerOperation[] = ['create', 'update', 'delete'];

export interface WebhookTrigger {
  type: TriggerType;
  operation: TriggerOperation;
}

export type WebhookId = string;
export interface WebhookResponse {
  id: WebhookId;
  url: string;
  token: string;
  isEnabled: boolean;
  triggers: WebhookTrigger[];
}
